module.exports = __webpack_public_path__ + "assets/2eb7109e9bf656dd8cd5eb42b4dac305.mp3";